module.exports = __webpack_public_path__ + "static/video-cover-image-4a12dfaffd6e4a57cbe39bfe1f6998b8.png";